import React, { Component } from "react"

/* Constants */
import { env, utils } from "../constants"

/* Components */
import { Picture } from "@cuba-go/poker-ui"


class GamePayout extends Component {

    minmax = () => {
        const { max, min, currency } = this.props
        return <span className="minmax">&nbsp;&nbsp; {utils.convertor(min, currency)} - {utils.convertor(max, currency)}</span>
    }

    render = () => {

        const { maxPay, currency } = this.props

        return (
            <>

                <div className="game-payout-top">
                    <div className="game-payout-top-row">
                        <p>Дополнительная комбинация засчитывается только если содержит хотя бы одну карту вне основной</p>
                    </div>
                </div>

                <div className="head second">
                    <p>Максимальная выплата</p>
                    <p className="price">{utils.convertor(maxPay, currency, " ")}</p>
                </div>

                <div className="payout-scroll">
                <div className="row">
                    <p>Комбинации</p>
                    <p>Выплата</p>
                </div>
                <div className="combinations">
                    <div className="item">
                        <p>Туз-король</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/aceKing.svg`} alt="aceking" />
                        </div>
                        <p className="result">1:1</p>
                    </div>
                    <div className="item">
                        <p>Пара</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/pair.svg`} alt="pair" />
                        </div>
                        <p className="result">1:1</p>
                    </div>
                    <div className="item">
                        <p>Две пары</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/twopairs.svg`} alt="twopairs" />
                        </div>
                        <p className="result">2:1</p>
                    </div>
                    <div className="item">
                        <p>Тройка</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/threeofakind.svg`} alt="twopairs" />
                        </div>
                        <p className="result">3:1</p>
                    </div>
                    <div className="item">
                        <p>Стрит</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/street.svg`} alt="twopairs" />
                        </div>
                        <p className="result">4:1</p>
                    </div>
                    <div className="item">
                        <p>Флеш</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/flash.svg`} alt="twopairs" />
                        </div>
                        <p className="result">5:1</p>
                    </div>
                    <div className="item">
                        <p>Фулл хаус</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/fullhouse.svg`} alt="twopairs" />
                        </div>
                        <p className="result">7:1</p>
                    </div>
                    <div className="item">
                        <p>Каре</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/fourofakind.svg`} alt="twopairs" />
                        </div>
                        <p className="result">20:1</p>
                    </div>
                    <div className="item">
                        <p>Стрит флеш</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/streetFlash.svg`} alt="twopairs" />
                        </div>
                        <p className="result">50:1</p>
                    </div>
                    <div className="item">
                        <p>Рояль флеш</p>
                        <div>
                            <Picture src={`${env.mediapoint}/images/combinations/royalFlash.svg`} alt="twopairs" />
                        </div>
                        <p className="result">100:1</p>
                    </div>
                </div>

                <div className="row">
                    <p>Двойные комбинации</p>
                    <p>Выплата</p>
                </div>
                <div className="combinations double">
                    <div className="item">
                        <p style={{ width: "78%" }}>Пара + Туз-король</p>
                        <p className="result">2:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Две пары + Туз-король</p>
                        <p className="result">3:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Тройка + Туз-король</p>
                        <p className="result">4:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Три пары</p>
                        <p className="result">4:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Стрит + Пара</p>
                        <p className="result">5:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Флеш + Пара</p>
                        <p className="result">6:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Стрит из 6 карт</p>
                        <p className="result">8:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Флеш из 6 карт</p>
                        <p className="result">10:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Фулл хаус + Тройка</p>
                        <p className="result">14:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Каре + Туз-король</p>
                        <p className="result">21:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Каре + Пара</p>
                        <p className="result">27:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Стрит флеш + Туз-король</p>
                        <p className="result">51:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Стрит флеш + Стрит</p>
                        <p className="result">54:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Стрит флеш + Флеш</p>
                        <p className="result">55:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Стрит флеш из 6 карт</p>
                        <p className="result">100:1</p>
                    </div>
                    <div className="item">
                        <p style={{ width: "78%" }}>Большой рояль флеш</p>
                        <p className="result">150:1</p>
                    </div>
                </div>
                </div>
            </>
        )
    }
}

export default GamePayout